import { Container, Grid, Typography, makeStyles } from "@material-ui/core";
import { getOrderDate } from "../utils";
import { ITheme } from "../constants/theme";

export const CollectionOrderHistory = (props: any) => {
  const classes = useStyles();
  const data: any = props.data;

  const statuses = [
    { label: 'Get Quote', value: data?.Drafted },
    { label: 'Placed', value: data?.Placed },
    { label: 'Queued', value: data?.Queued },
    { label: 'Assigned', value: data?.Assigned },
    { label: 'At pick up location', value: data?.AtPickUpLocation },
    { label: 'Out for delivery', value: data?.OutForDelivery },
    { label: 'At drop off location', value: data?.AtDropOffLocation },
    { label: 'Delivered', value: data?.Delivered },
    { label: 'Failed', value: data?.Failed },
    { label: 'Cancelled', value: data?.Cancelled }
  ].filter(s => Boolean(s.value) && Boolean(s.label));

  return (
    <Container className={classes.basicInformationContainer}>
      <Grid container>
        <Grid container className={classes.infoTitle}>
          <Typography variant="h6" component="span">
            Collection Order history
          </Typography>
        </Grid>
        {statuses.map(s =>
          <Grid key={s.label} container className={classes.infoTextContainer}>
            <Grid item xs={3} style={{ paddingRight: '24px' }}>
              <Typography
                display="inline"
                variant="caption"
                component="span"
                color="textSecondary"
                style={{ textTransform: 'uppercase' }}>
                {s.label}
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.colOffset}>
              <Typography variant="body1" component="span" color="textPrimary">
                {getOrderDate(s.value)}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  basicInformationContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 0",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
  },
  infoTitle: {
    marginBottom: 20,
  },
  infoTextContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    '&:not(:last-child)': {
      borderBottom: "1px solid rgba(0, 0, 0, 0.08)"
    }
  },
  infoTextContainerLastRow: {
    paddingTop: 15,
    paddingBottom: 15,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
}));
